//Burger Builder
export const SET_BURGER_DATA = 'SET_BURGER_DATA';
export const ADD_INGREDIENT = 'ADD_INGREDIENT';
export const REMOVE_INGREDIENT = 'REMOVE_INGREDIENT';
export const SET_SERVER_BURGER_DATA = 'SET_SERVER_BURGER_DATA';
export const SET_IS_BUILDING = 'TOGGLE_IS_BUILDING';

//Orders
export const GET_ORDERS = 'GET_ORDERS';
export const TOGGLE_ORDERS_LOADING = 'TOGGLE_ORDERS_LOADING';
export const SET_NEXT_ID = 'SET_NEXT_ID';

//Checkout
export const ADD_ORDER = 'ADD_ORDER';
export const SUBMIT_ORDER = 'SUBMIT_ORDER';
export const TOGGLE_ORDER_SENDING = 'TOGGLE_ORDER_SENDING';
export const DISPLAY_FORM_ERROR = 'DISPLAY_FORM_ERROR';

//Global
export const DISPLAY_PAGE_ERROR = 'DISPLAY_PAGE_ERROR';
export const CLEAR_PAGE_ERROR = 'CLEAR_PAGE_ERROR';
export const TOGGLE_MODAL = 'TOGGLE_MODAL';
export const TOGGLE_DRAWER = 'TOGGLE_DRAWER';
export const TOGGLE_MENU_MOUSE_TRACKER = 'TOGGLE_MENU_MOUSE_TRACKER';
export const TOGLE_USER_MENU = 'TOGGLE_USER_MENU';
export const LOG_CURRENT_PATH = 'LOG_CURRENT_PATH';

//Authorization
export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAILED = 'AUTH_FAILED';
export const CLEAR_AUTH_ERROR = 'CLEAR_AUTH_ERROR';
export const LOGOUT = 'LOGOUT';
export const LOGOUT_TIMEOUT_SET = 'LOGOUT_TIMEOUT_SET';
export const SET_USER_DATA = 'SET_USER_DATA';
export const SET_LOGIN_REDIRECT = 'SET_LOGIN_REDIRECT';




// WEBPACK FOOTER //
// ./src/store/actions/actionTypes.jsx